export default function getResource(label) {
    const resources = {
        modalTitle: 'Add Address',
        setAsDefault: 'Set as default delivery address',
        enterAddressManually: 'Enter address manually',
        cancel: 'Cancel',
        confirm: 'Use This Address'
    };

    return resources[label];
}
